export interface IListFilters {
  search: string
  status: '' | 'PENDENTE' | 'APROVADO' | 'REPROVADO'
  teacher: string
  type: '' | 'trabalho-de-conclusão' | 'pesquisa-de-campo'
  course: {
    format: string
    name: string
  }
  created_at: {
    from: string
    to: string
  }
}

export enum EEntregaDeTrabalhoType {
  'trabalho-de-conclusão' = 'Trabalho de conclusão',
  'pesquisa-de-campo' = 'Pesquisa de campo'
}

export interface IEntregaDeTrabalho {
  id: number
  public_id: string
  name: string
  responsable_name: string
  course: string
  format: string
  teacher: string
  'class-days': string
  'class-hours': string
  type: 'trabalho-de-conclusão' | 'pesquisa-de-campo'
  status: 'PENDENTE' | 'APROVADO' | 'REPROVADO'
  created_at: string
  review_grade: string
  review_teacher: string
  review_created_at: string
  time_taken_seconds: number | null
}

export interface IEntregaDeTrabalhoComplete {
  id: number
  public_id: string
  status: 'PENDENTE' | 'APROVADO' | 'REPROVADO'
  name: string
  cpf: string
  responsable_name: string | null
  responsable_cpf: string | null
  email: string
  phone: string
  format: string
  course: string
  teacher: string
  'class-days': string
  'class-hour-start': string
  'class-hour-ends': string
  type: 'trabalho-de-conclusão' | 'pesquisa-de-campo'
  created_at: string
  updated_at: string
  uploads: IEntregaDeTrabalhoUpload[]
  review: IEntregaDeTrabalhoReviewFilled | null
}

export interface IEntregaDeTrabalhoUpload {
  id: number
  original_name: string
  path: string
  size: string
  created_at: string
  updated_at: string
}

export interface IEntregaDeTrabalhoReviewFilled {
  id: number
  entrega_de_trabalho_id: number
  user_id: number
  teacher: string
  course_load: string
  start_date: string
  end_date: string
  contract_number: string
  class_code: string
  observations: string
  grade: string
  created_at: string
  updated_at: string
}

export const statusColors = {
  PENDENTE: 'yellow',
  APROVADO: 'green',
  REPROVADO: 'red'
}

export interface IStatistics {
  total: number
  pendente: number
  aprovado: number
  reprovado: number
}

export interface IReviewed {
  delayed: number
  not_delayed: number
}

export interface INotReviewed {
  delayed: number
  not_delayed: number
}

export interface IReviewTimeStatistics {
  reviewed: IReviewed
  not_reviewed: INotReviewed
  average_time_in_seconds: string
}

export interface IEntregaDeTrabalhoReview {
  teacher: string
  course_load: string
  start_date: string
  end_date: string
  contract_number: string
  class_code: string
  observations: string
  grade: string
}
